(() => {
  const listSelector =
    'ul.product-grid ul.ul-swatches-list.g-variant-color';

  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function getItems(track) {
    return Array.from(track.children).filter((item) =>
      item.matches('li.swatches-options')
    );
  }

  function updateCarousel(wrapper) {
    const track = wrapper.querySelector('ul.ul-swatches-list');
    const previousButton = wrapper.querySelector(
      '.swatch-carousel__button--previous'
    );
    const nextButton = wrapper.querySelector(
      '.swatch-carousel__button--next'
    );

    if (!track || !previousButton || !nextButton) return;

    const items = getItems(track);
    const isActive = mobileQuery.matches && items.length > 2;

    wrapper.classList.toggle('is-active', isActive);

    if (!isActive) {
      previousButton.disabled = true;
      nextButton.disabled = true;
      return;
    }

    const maximumScroll = Math.max(
      0,
      track.scrollWidth - track.clientWidth
    );

    previousButton.disabled = track.scrollLeft <= 1;
    nextButton.disabled =
      track.scrollLeft >= maximumScroll - 1;
  }

  function moveCarousel(wrapper, direction) {
    const track = wrapper.querySelector('ul.ul-swatches-list');
    const items = getItems(track);

    if (items.length <= 2) return;

    const firstOffset = items[0].offsetLeft;
    const positions = items.map(
      (item) => item.offsetLeft - firstOffset
    );

    const currentIndex = positions.reduce(
      (closestIndex, position, index) => {
        const currentDistance = Math.abs(
          position - track.scrollLeft
        );

        const closestDistance = Math.abs(
          positions[closestIndex] - track.scrollLeft
        );

        return currentDistance < closestDistance
          ? index
          : closestIndex;
      },
      0
    );

    const lastStartIndex = Math.max(0, items.length - 2);
    let targetIndex;

    if (direction > 0) {
      targetIndex = Math.min(
        currentIndex + 2,
        lastStartIndex
      );
    } else {
      const stepBack =
        currentIndex === lastStartIndex &&
        lastStartIndex % 2 !== 0
          ? 1
          : 2;

      targetIndex = Math.max(
        currentIndex - stepBack,
        0
      );
    }

    track.scrollTo({
      left: positions[targetIndex],
      behavior: 'smooth',
    });
  }

  function removeCarousel(wrapper) {
    const track = wrapper.querySelector(
      'ul.ul-swatches-list'
    );

    if (!track || !wrapper.parentNode) {
      wrapper.remove();
      return;
    }

    if (wrapper.isitglowScrollHandler) {
      track.removeEventListener(
        'scroll',
        wrapper.isitglowScrollHandler
      );
    }

    wrapper.parentNode.insertBefore(track, wrapper);
    wrapper.remove();
  }

  function enhanceCarousel(track) {
    if (!mobileQuery.matches) return;

    const existingWrapper = track.closest(
      '.isitglow-swatch-carousel'
    );

    if (existingWrapper) {
      updateCarousel(existingWrapper);
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'isitglow-swatch-carousel';

    const previousButton = document.createElement('button');
    previousButton.type = 'button';
    previousButton.className =
      'swatch-carousel__button swatch-carousel__button--previous';
    previousButton.setAttribute(
      'aria-label',
      'Предишни цветове'
    );
    previousButton.textContent = '‹';

    const nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className =
      'swatch-carousel__button swatch-carousel__button--next';
    nextButton.setAttribute(
      'aria-label',
      'Следващи цветове'
    );
    nextButton.textContent = '›';

    track.parentNode.insertBefore(wrapper, track);
    wrapper.append(previousButton, track, nextButton);

    previousButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      moveCarousel(wrapper, -1);
    });

    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      moveCarousel(wrapper, 1);
    });

    const scrollHandler = () => {
      window.requestAnimationFrame(() => {
        updateCarousel(wrapper);
      });
    };

    wrapper.isitglowScrollHandler = scrollHandler;
    track.addEventListener('scroll', scrollHandler);

    window.requestAnimationFrame(() => {
      updateCarousel(wrapper);
    });
  }

  function initializeCarousels() {
    if (!mobileQuery.matches) {
      document
        .querySelectorAll('.isitglow-swatch-carousel')
        .forEach(removeCarousel);

      return;
    }

    document
      .querySelectorAll(listSelector)
      .forEach(enhanceCarousel);
  }

  const observer = new MutationObserver(() => {
    initializeCarousels();
  });

  function start() {
    initializeCarousels();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  mobileQuery.addEventListener(
    'change',
    initializeCarousels
  );
})();